var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLinks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_11627435",
    clipPath: "url(#clip0_2401_6484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.061 15.6587L26.4269 10.0246C21.7595 5.35719 14.1921 5.35719 9.52463 10.0246C4.85719 14.6921 4.85719 22.2595 9.52463 26.9269L15.1587 32.561C19.8262 37.2285 27.3936 37.2285 32.0609 32.561C36.7285 27.8936 36.7285 20.3262 32.061 15.6587ZM26.4269 21.2928C27.9803 22.8462 27.9803 25.3736 26.4269 26.9269C24.8736 28.4803 22.3462 28.4803 20.7928 26.9269L15.1587 21.2928C13.6054 19.7395 13.6054 17.2121 15.1587 15.6587C16.7121 14.1054 19.2395 14.1054 20.7928 15.6587L26.4269 21.2928Z",
    fill: "#D9F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.4269 10.0246L29.2439 12.8416C27.6882 11.2858 25.1656 11.2858 23.6098 12.8416C22.0541 14.3974 22.0541 16.9199 23.6098 18.4757L20.7928 15.6587C19.2395 14.1054 16.7121 14.1054 15.1587 15.6587C13.6054 17.2121 13.6054 19.7395 15.1587 21.2928L17.9757 24.1098C16.4199 22.5541 13.8974 22.5541 12.3416 24.1098C10.7858 25.6656 10.7858 28.1882 12.3416 29.7439L9.52463 26.9269C4.85719 22.2595 4.85719 14.6921 9.52463 10.0246C14.1921 5.35719 21.7595 5.35719 26.4269 10.0246Z",
    fill: "#00A6A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.9391 34.439C29.2716 39.1064 29.2716 46.6738 33.9391 51.3413L39.5732 56.9754C44.2406 61.6428 51.8081 61.6428 56.4755 56.9754C61.1429 52.3079 61.1429 44.7405 56.4755 40.0731L50.8414 34.439C46.1738 29.7715 38.6064 29.7717 33.9391 34.439ZM50.8413 45.7072C52.3946 47.2605 52.3946 49.788 50.8413 51.3413C49.2879 52.8946 46.7605 52.8946 45.2072 51.3413L39.573 45.7072C38.0197 44.1538 38.0197 41.6264 39.573 40.0731C41.1264 38.5197 43.6538 38.5197 45.2072 40.0731L50.8413 45.7072Z",
    fill: "#D9F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.8413 34.4389L53.6583 37.2559C52.1025 35.7002 49.5799 35.7002 48.0242 37.2559C46.4684 38.8117 46.4684 41.3343 48.0242 42.89L45.2072 40.0731C43.6539 38.5197 41.1264 38.5197 39.5731 40.0731C38.0197 41.6264 38.0197 44.1538 39.5731 45.7072L42.3901 48.5241C40.8343 46.9684 38.3117 46.9684 36.756 48.5241C35.2002 50.0799 35.2002 52.6025 36.756 54.1583L33.939 51.3413C29.2715 46.6738 29.2715 39.1064 33.939 34.4389C38.6064 29.7715 46.1738 29.7715 50.8413 34.4389Z",
    fill: "#00A6A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.4511 41.9511C39.8978 43.5044 37.3703 43.5044 35.817 41.9511L24.5488 30.6829C22.9955 29.1296 22.9955 26.6021 24.5488 25.0488C26.1021 23.4955 28.6296 23.4955 30.1829 25.0488L41.4511 36.317C43.0044 37.8703 43.0044 40.3978 41.4511 41.9511Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.0671 18.5671C16.5137 20.1204 13.9863 20.1204 12.4329 18.5671L1.16474 7.29885C-0.388582 5.74553 -0.388582 3.21807 1.16474 1.66475C2.71806 0.111426 5.24552 0.111426 6.79884 1.66475L18.0671 12.933C19.6204 14.4863 19.6204 17.0137 18.0671 18.5671Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.7475 8.61344L6.79884 1.66475C5.24552 0.111426 2.71806 0.111426 1.16474 1.66475C-0.388582 3.21807 -0.388582 5.74553 1.16474 7.29885L8.11343 14.2475C6.55766 12.6918 6.55766 10.1692 8.11343 8.61344C9.66933 7.0578 12.1916 7.05767 13.7475 8.61344Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.8351 65.3351C63.2817 66.8884 60.7543 66.8884 59.201 65.3351L47.9328 54.0669C46.3794 52.5135 46.3794 49.9861 47.9328 48.4328C49.4861 46.8794 52.0135 46.8794 53.5669 48.4328L64.8351 59.701C66.3884 61.2543 66.3884 63.7818 64.8351 65.3351Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M60.5154 55.3813L53.5669 48.4328C52.0135 46.8794 49.4861 46.8794 47.9328 48.4328C46.3794 49.9861 46.3794 52.5135 47.9328 54.0669L54.8814 61.0156C53.3257 59.4598 53.3257 56.9372 54.8814 55.3814C56.4372 53.8257 58.9596 53.8257 60.5154 55.3813Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.1316 31.9975L30.183 25.0489C28.6297 23.4956 26.1022 23.4956 24.5489 25.0489C22.9956 26.6022 22.9956 29.1297 24.5489 30.683L31.4976 37.6317C29.9418 36.0759 29.9418 33.5534 31.4976 31.9976C33.0534 30.4418 35.5758 30.4418 37.1316 31.9975Z",
    fill: "#B0E3E3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.6727 42.7945C13.2811 44.7063 18.7541 47.8604 25.0396 46.4492C26.0248 46.2279 26.418 45.0298 25.7477 44.2746C23.4819 41.7219 18.2276 37.3107 10.923 40.503C9.98289 40.9139 9.84508 42.188 10.6727 42.7945Z",
    fill: "#FFDA45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M40.7633 9.34335C42.1669 11.4011 44.0529 15.0854 43.3411 19.3078C43.1636 20.3606 41.8682 20.7664 41.1029 20.0219C39.1991 18.1702 36.5809 14.5295 38.4237 9.61303C38.8004 8.60794 40.1586 8.45674 40.7633 9.34335Z",
    fill: "#FFEE6E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2401_6484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLinks);
export default __webpack_public_path__ + "static/media/EmptyLinks.36faa771afbfc22a017bc79d9b5f32ca.svg";
export { ForwardRef as ReactComponent };